import { Book, CheckCircle, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

const bookCover = "https://customer-assets.emergentagent.com/job_choice-omw-launch/artifacts/k3zv8xly_IMG_5405.png";

const Shop = () => {
  const benefits = [
    "The 60/40 Principle - Build wealth automatically",
    "Discover & monetize your God-given gifts",
    "5-Phase Transition Plan to escape the 9-to-5",
    "7 types of income streams to build",
    "Worksheets & templates included"
  ];

  return (
    <section id="shop" className="py-20 lg:py-28 bg-gradient-to-br from-accent via-accent/95 to-navy relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 text-gold/20 text-6xl">✦</div>
      <div className="absolute bottom-20 right-20 text-gold/15 text-8xl">✦</div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            <Badge className="bg-gold/20 text-gold border-gold/30 mb-6">
              <Book className="w-3 h-3 mr-1" />
              Featured Ebook
            </Badge>

            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-cream leading-tight mb-4">
              Stop Living
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-gold via-secondary to-gold-light">
                Paycheck to Paycheck
              </span>
            </h2>

            <p className="text-xl text-champagne font-medium mb-2">
              Real Solutions to Build Wealth
            </p>

            <p className="text-champagne/80 leading-relaxed mb-8 max-w-lg">
              Discover the proven system that helped me leave the corporate world and build financial freedom through purpose. 
              This isn't about cutting coupons—it's about transforming your entire relationship with money.
            </p>

            {/* Benefits */}
            <div className="space-y-3 mb-8">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-3 text-left">
                  <CheckCircle className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
                  <span className="text-cream/90">{benefit}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button asChild size="lg" className="bg-gold hover:bg-gold/90 text-accent font-bold px-8 rounded-full">
                <a href="https://omwbusiness.com/promo" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                  Get Your Copy
                  <ExternalLink className="w-4 h-4" />
                </a>
              </Button>
              <div className="flex items-center justify-center lg:justify-start gap-2 text-champagne/70">
                <span className="text-gold font-bold">50% OFF</span>
                <span className="text-sm">Limited Time</span>
              </div>
            </div>
          </div>

          {/* Actual Ebook Cover */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-gold/30 to-primary/20 blur-3xl scale-110" />
              <div className="relative">
                <img 
                  src={bookCover} 
                  alt="Stop Living Paycheck to Paycheck Ebook" 
                  className="w-72 md:w-80 lg:w-96 rounded-lg shadow-2xl"
                />
                
                {/* Badge */}
                <div className="absolute -top-3 -right-3 bg-primary text-primary-foreground px-4 py-2 rounded-full font-bold text-sm shadow-lg">
                  50% OFF!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Shop;
